import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

export type ContentProps = ComponentProps<'div'>;

export function Content({ className, ...props }: ContentProps) {
  return (
    <div
      className={twMerge('flex justify-between gap-4', className)}
      {...props}
    />
  );
}
